import React from 'react';
import {CircularProgress} from '@mui/material';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'promoted' | 'blue' | 'custom';
  disabled?: boolean;
  iconStart?: React.ReactNode;
  iconEnd?: React.ReactNode;
  className?: string;
  px?: string;
  py?: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

function AppButton({
  variant = 'secondary',
  disabled = false,
  iconStart,
  iconEnd,
  className,
  px,
  py,
  children,
  isLoading,
  ...rest
}: Props) {
  return (
    <button
      disabled={isLoading || disabled}
      className={`rounded-[100px] font-medium flex items-center gap-2 whitespace-nowrap cursor-pointer transition-all duration-200 ${
        variant == 'primary' || variant == 'blue' || disabled || isLoading
          ? disabled || isLoading
            ? 'bg-[#76768033] cursor-not-allowed text-[#3C3C4373]'
            : variant == 'primary'
              ? 'bg-tealBlue text-[16px] leading-5 text-white hover:opacity-90'
              : 'bg-darkBlue text-[16px] leading-5 text-white hover:opacity-90'
          : variant == 'secondary'
            ? 'bg-white border-1 border-gray text-[16px] leading-5 text-darkerGray hover:border-tealBlue'
            : variant == 'promoted' &&
              'bg-aqua shadow-md text-xl font-semibold text-darkerGray hover:bg-softAqua'
      }
      ${className}`}
      style={{
        ...rest.style,
        paddingInline: px ? px : '1.5rem',
        paddingBlock: py ? py : '0.5rem',
      }}
      {...rest}>
      {iconStart && iconStart}
      {isLoading ? <CircularProgress size={20} /> : children}
      {iconEnd && iconEnd}
    </button>
  );
}

export default AppButton;
